module.exports = __webpack_public_path__ + "img/right-drawn-arrow.8ef2b61f.svg";